import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import TabNavigation from "../../components/TabNavigation/TabNavigation";

const navigationItems = [
  { to: "/settings/general", text: "General" },
  { to: "/settings/maintenance", text: "Maintenance" },
  { to: "/settings/payment", text: "Payment" },
];

const SettingsLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/settings") {
      navigate("/settings/general");
    }
  }, [location]);

  return (
    <div>
      <TabNavigation items={navigationItems} />
      <div className={"page-content"}>
        <Outlet />
      </div>
    </div>
  );
};

export default SettingsLayout;
